const compareNames = (a, b) => (a || '').localeCompare(b || '', undefined, { sensitivity: 'base', numeric: true });

export const getCategoryTrail = (category, categories) => {
  const byId = new Map(categories.map(item => [item.id, item]));
  const trail = [];
  const visited = new Set();
  let current = category;

  while (current && !visited.has(current.id)) {
    visited.add(current.id);
    trail.unshift(current);
    current = byId.get(current.parentorganizationcategoryid);
  }

  return trail;
};

export const getCategoryPath = (category, categories) => {
  const names = getCategoryTrail(category, categories).map(item => item.name);

  if (names.length === 1 && category.parentname) {
    const parentName = category.parentname.trim();
    if (parentName && parentName !== category.name) {
      return parentName.endsWith(category.name) ? parentName : `${parentName} › ${category.name}`;
    }
  }

  return names.join(' › ');
};

export const buildPortalCatalog = (groups = []) => {
  const organizations = groups
    .map(group => {
      const categories = [...(group.categories || [])].sort((a, b) =>
        compareNames(getCategoryPath(a, group.categories || []), getCategoryPath(b, group.categories || [])) || a.id - b.id
      );
      const roots = categories.filter(category => category.parentorganizationcategoryid == null);

      return {
        ...group,
        categories,
        roots,
        rootCount: roots.length,
      };
    })
    .sort((a, b) => compareNames(a.organizationname, b.organizationname) || a.organizationid - b.organizationid);

  const searchOptions = organizations.flatMap(group => group.categories.map(category => ({
    ...category,
    organizationname: group.organizationname,
    path: getCategoryPath(category, group.categories),
  })));

  return { organizations, searchOptions };
};
